import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import '../../styles/AddressSearch.css';

const AddressSearch = ({ onAddressSelect, onCoordinatesSelect, onCloseModal }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isLocationSelected, setIsLocationSelected] = useState(false);
  const searchRef = useRef(null);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      Swal.fire({
        title: '⚠️ Campo vacío',
        text: 'Por favor ingresa una dirección',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
      return;
    }

    try {
      console.log("🔍 Buscando dirección:", searchTerm);
      
      // Usar OpenStreetMap Nominatim API (gratuita y sin API key)
      const searchUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchTerm)}&limit=1&addressdetails=1&accept-language=es`;
      
      const response = await fetch(searchUrl);
      const data = await response.json();
      
             if (data && data.length > 0) {
         const searchResult = data[0];
         const coordinates = {
           lat: parseFloat(searchResult.lat),
           lng: parseFloat(searchResult.lon),
           address: searchResult.display_name || searchTerm
         };

         console.log("📍 DIRECCIÓN ENCONTRADA:", coordinates);

         // Notificar al componente padre para centrar el mapa
         if (onAddressSelect) {
           onAddressSelect(coordinates);
         }
         
         if (onCoordinatesSelect) {
           onCoordinatesSelect(coordinates.lat, coordinates.lng);
         }

         setIsLocationSelected(true);

         // Mostrar SweetAlert de confirmación
         const result = await Swal.fire({
          title: '📍 Ubicación Encontrada',
          html: `
            <div style="text-align: left; margin: 20px 0;">
              <p><strong>Dirección:</strong> ${coordinates.address}</p>
              <p><strong>Coordenadas:</strong></p>
              <p>• Latitud: ${coordinates.lat.toFixed(6)}</p>
              <p>• Longitud: ${coordinates.lng.toFixed(6)}</p>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'Confirmar Ubicación',
          confirmButtonColor: '#28a745',
          showCancelButton: true,
          cancelButtonText: 'Cambiar',
          cancelButtonColor: '#6c757d',
          reverseButtons: true
        });
        
        if (result.isConfirmed) {
          // Ubicación confirmada - cerrar modal automáticamente
          console.log("✅ Ubicación confirmada por el usuario - cerrando modal");
          
          if (onCloseModal) {
            onCloseModal();
          }
          
          setTimeout(() => {
            setIsLocationSelected(false);
          }, 1000);
          
        } else {
          // Usuario quiere cambiar
          setSearchTerm('');
          setIsLocationSelected(false);
        }
        
      } else {
        // No se encontró la dirección
        Swal.fire({
          title: '❌ Dirección no encontrada',
          text: 'No se pudo encontrar la dirección especificada. Intenta con una dirección más específica.',
          icon: 'warning',
          confirmButtonText: 'Entendido'
        });
      }
      
    } catch (error) {
      console.error('Error procesando dirección:', error);
      Swal.fire({
        title: '❌ Error',
        text: 'No se pudo procesar la dirección. Intenta de nuevo.',
        icon: 'error',
        confirmButtonText: 'Entendido'
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
    setIsLocationSelected(false);
  };

  return (
    <div className="address-search-container" ref={searchRef}>
      <div className={`search-input-wrapper ${isLocationSelected ? 'location-selected' : ''}`}>
        <i className="fas fa-search search-icon"></i>
        <input
          type="text"
          className="address-search-input"
          placeholder="Escribe tu dirección..."
          value={searchTerm}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
        {searchTerm && (
          <button 
            className="clear-search-btn" 
            onClick={clearSearch}
            type="button"
          >
            <i className="fas fa-times"></i>
          </button>
        )}
        {isLocationSelected && (
          <div className="location-success">
            <i className="fas fa-check-circle"></i>
          </div>
        )}
      </div>
      
      {/* Botón de búsqueda */}
      <button 
        className="search-button"
        onClick={handleSearch}
        disabled={!searchTerm.trim()}
      >
        <i className="fas fa-search"></i>
        Buscar
      </button>
      
      {/* Indicador de dirección seleccionada */}
      {isLocationSelected && (
        <div className="selected-address">
          <i className="fas fa-map-marker-alt"></i>
          <span>Dirección: {searchTerm}</span>
          <small>Se marcará en el mapa</small>
        </div>
      )}
    </div>
  );
};

export default AddressSearch;
